export default "__VITE_ASSET__DddAMTzz__"